import { useMutation } from '@tanstack/react-query';
import { sessionStore } from '../services/sessionStore';

/**
 * Email and password sign-in. On success the session is signed in and the app
 * swaps the login screen for the shell; on failure the mutation's `error` is
 * the request's, for the form to show.
 *
 * The form is the one place a failure is reported, so the app's global error
 * toast is turned off: it would add axios's generic "Request failed with
 * status code 401" on top of the server's own words.
 */
export const useSignIn = () =>
  useMutation({
    mutationFn: ({ email, password }) => sessionStore.signInWithCredentials({ email, password }),
    meta: { skipGlobalErrorToaster: true },
  });
